<template>
  <div>
    <listFilter
      :formItems="formItems"
      :filter="filter"
      @searchTableInfo="searchTableInfo"
      @resetTableInfo="resetTableInfo"
      @draft="draft"
    />
    <Card v-for="(item, index) in dataSource" :key="index">
       <p slot="title">{{ item.title }}</p>
        <Row>
          <Col :xs="24" :sm="12" :md="8" :lg="6" v-for="(ele, i) in item.tplConfigList" :key="i">
            <div class="colCard">
              <p class="colCardTitle">{{ ele.tplName }}</p>
              <p class="colCardContent" @click="lauchFlow(ele.id)">发起流程>></p>
            </div>
          </Col>
        </Row>
    </Card>
    <draft-modal :draftModalFlag="draftModalFlag" @cancelDraftModal="cancelDraftModal" />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import listMixins from '@/mixins/listMixins';
import { formItems } from './config';
import draftModal from './template/draftModal/draftModal.vue'; // 草稿弹窗
export default {
  name: 'launchApprovalList',
  mixins: [listMixins],
  components: { draftModal },
  data() {
    return {
      formItems,
      filter: { tplName: '' },
      draftModalFlag: false, // 草稿弹窗
      draftCount: 0
    };
  },
  computed: {
    ...mapState('lauchApproval', ['dataSource']),
    ...mapState('approvalDraftList', ['totalCount'])
  },
  watch: {
    totalCount(val) {
      this.formItems[1].buttonArr[2].message = `草稿箱(${val || 0})`;
    }
  },
  methods: {
    ...mapActions('lauchApproval', ['getTableInfo']),
    lauchFlow(id) {
      // this.getFormDataJson(id);
      this.$router.push({ path: '/launchApprovalDetail', query: { id } });
    },
    // 草稿箱
    draft() {
      this.draftModalFlag = true;
    },
    cancelDraftModal(e) {
      this.draftModalFlag = e;
    }
  }
};
</script>
<style lang="less">
.colCard{
  border: 1px solid #ddd;
  border-radius: 10px;
  margin: 8px;
  padding: 8px;
  overflow: hidden;
  background: #f5f7f9
}
.colCardTitle{
  font-size: 22px;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 8px 0;
}
.colCardContent{
  color: blueviolet;
  font-weight: 500;
  float: right;
  cursor: pointer;
}
</style>
